"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactPlayer = require("react-player");

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _Stores = require("../../components/stores/Stores");

var _Stores2 = _interopRequireDefault(_Stores);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaaApp = function (_Component) {
  (0, _inherits3.default)(MaaApp, _Component);

  function MaaApp() {
    (0, _classCallCheck3.default)(this, MaaApp);
    return (0, _possibleConstructorReturn3.default)(this, (MaaApp.__proto__ || (0, _getPrototypeOf2.default)(MaaApp)).apply(this, arguments));
  }

  (0, _createClass3.default)(MaaApp, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Tietoa palvelusta" }),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "h2",
            { className: "h3" },
            "MaaApp-sovelluksella reaaliaikaista tietoa kuljetuksista."
          ),
          _react2.default.createElement(
            "div",
            { className: "player-wrapper" },
            _react2.default.createElement(_reactPlayer2.default, {
              className: "react-player",
              url: "https://www.youtube.com/watch?v=HsPPv-4YwcA",
              width: "100%",
              height: "100%",
              config: {
                youtube: {
                  playerVars: {
                    autoplay: 0,
                    modestbranding: 1,
                    hl: "fi",
                    rel: 0
                  }

                }
              }
            })
          ),
          _react2.default.createElement("br", null),
          _react2.default.createElement(_Stores2.default, null),
          _react2.default.createElement(
            "h2",
            { className: "h4" },
            "MaaApp on kuljettajan ty\xF6kalu, jota k\xE4ytet\xE4\xE4n \xE4lypuhelimella tai tabletilla."
          ),
          _react2.default.createElement(
            "ul",
            null,
            _react2.default.createElement(
              "li",
              null,
              "MaaApp-sovellusta k\xE4ytet\xE4\xE4n yhdess\xE4 Maap\xF6rssin sivulla olevan Projektit-osion kanssa. Projektin  perustaja  voi hallita yksitt\xE4ist\xE4 projektia/ty\xF6maata ja sen tietoja"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Projekti perustetaan Maap\xF6rssin sivulla ja sen tiedot n\xE4kyv\xE4t vain projektin j\xE4senille. J\xE4seni\xE4 voivat olla mm. tilaaja, vastaanottopaikka, PIMA - valvoja, kuljetusliike, kuljettaja, urakoitsija, laskuttaja jne. Projektin perustaja kutsuu muut k\xE4ytt\xE4j\xE4t puhelinnumerolla/s\xE4hk\xF6postilla mukaan projektiin"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Perustaja tai/ja projektin j\xE4senet tekev\xE4t projektin sis\xE4isi\xE4 ilmoituksia maa-aineksista (vastaanotetaan/tarjotaan), joilla m\xE4\xE4ritet\xE4\xE4n nouto- ja vastaanottopaikat."
            ),
            _react2.default.createElement(
              "li",
              null,
              "Projektin kuljetustiedot (tarjotaan/vastaanotetaan ilmoitukset) siirtyv\xE4t kuljetusovellukseen, josta kuljettaja n\xE4kee l\xE4ht\xF6- ja toimitusosoitteet paikat."
            ),
            _react2.default.createElement(
              "li",
              null,
              "Kuljettajan tallentaessa puhelimellaan / tabletillaan kuljetustiedot (lastaus-, ajo- ja purkausajat) sovellukseen syntyy automaattisesti s\xE4hk\xF6inen siirtoasiakirja. Kun kuljettaja on kuitannut kuljetuksen valmiiksi, projektin j\xE4-senet voivat reaaliaikaisesti ladata ja tulostaa siirto asiakirjan Maap\xF6rssin sivuilta. Siirtoasiakirjat tallentuvat Maap\xF6rssin pilvipalveluun ja niit\xE4 s\xE4ilytet\xE4\xE4n 3 vuotta."
            ),
            _react2.default.createElement(
              "li",
              null,
              "Reaaliaikainen tiedonkulku MaaApp \u2013 kuljetussovelluksen kautta mahdollistaa monipuolisen raportoinnin. Projektin perustamisen ja kuljettajan sy\xF6tt\xE4mien operatiivisten tietojen avulla eri projektin j\xE4senet voivat muodostaa raportteja tarpeensa mukaan."
            ),
            _react2.default.createElement(
              "li",
              null,
              "Valitut tiedot voidaan siirt\xE4\xE4 jatkok\xE4sittely\xE4 varten haluttuun ohjelmaan, esim. Excel tai yritysten omiin toimin-nanohjausj\xE4rjestelmiin."
            )
          )
        )
      );
    }
  }]);
  return MaaApp;
}(_react.Component);

exports.default = MaaApp;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MaaApp/MaaApp.js
 ** module id = 1220
 ** module chunks = 0
 **/